var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27018",
    "data-name": "Group 27018",
    transform: "translate(-236 -245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_166",
    "data-name": "Ellipse 166",
    transform: "translate(236 245)",
    fill: "#fff",
    stroke: "#1c1c1c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27013",
    "data-name": "Group 27013",
    transform: "translate(-419 -145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2833",
    "data-name": "Rectangle 2833",
    d: "M1.956.856a.924.924,0,0,0-.978.856V13.694a.924.924,0,0,0,.978.856h18.1a.924.924,0,0,0,.978-.856V1.712a.924.924,0,0,0-.978-.856H1.956m0-.856h18.1a1.846,1.846,0,0,1,1.956,1.712V13.694a1.846,1.846,0,0,1-1.956,1.712H1.956A1.846,1.846,0,0,1,0,13.694V1.712A1.846,1.846,0,0,1,1.956,0Z",
    transform: "translate(664 402)",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    d: "M9.212,7.657,0,1.5V.327L9.755,6.843a1.4,1.4,0,0,0,1.521,0L21.52,0V1.176l-9.7,6.481a2.377,2.377,0,0,1-2.608,0Z",
    transform: "translate(664.244 403.762)",
    fill: "#1c1c1c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.10c746c1729355ebdd7b0cb7621368bf.svg";
export { ForwardRef as ReactComponent };